import React, { createContext, useContext, useMemo, useState } from "react";
const HeaderDockContext = createContext({ docked: false, setDocked: () => {} });

export function HeaderDockProvider({ children }) {
  const [docked, setDocked] = useState(false);
  const value = useMemo(() => ({ docked, setDocked }), [docked]);
  return <HeaderDockContext.Provider value={value}>{children}</HeaderDockContext.Provider>;
}
export function useHeaderDock() { return useContext(HeaderDockContext); }
